export default "__VITE_ASSET__DoJ97oBQ__"